export const fileTypeAcceptMap = {
  image: 'image/*',
  imageOrSvg: 'image/*,.svg',
  document: '.docx,.doc,.pages,.odt',
  documentsExtract: [
    '.csv',
    '.doc',
    '.docx',
    '.html',
    '.odg',
    '.odp',
    '.ods',
    '.odt',
    '.pdf',
    '.ppt',
    '.pptx',
    '.rtf',
    '.txt',
    '.xls',
    '.xlsx',
    '.xml',
  ].join(','),
  svg: 'image/svg+xml,.svg',
};

// TODO: Make fileType and accept mutually exclusive, but also allow neither... spent some time trying
// to get it to work with our generic XOR type, didn't succeeed
export type AcceptType = { fileType?: keyof typeof fileTypeAcceptMap; accept?: string };

export type FileFieldBaseProps = AcceptType & {
  label?: string;
  hideLabel?: boolean;
  error?: string;
  placeholder?: string;
  language?: 'en' | 'is';
  isDisabled?: boolean;
};

export type DefaultFile = {
  id: string;
  name: string;
  src: string;
  attachmentId?: number;
};
